<div class="page">
  <div class="header-page">
    <div class="title">
      Personnalisation
    </div>
  </div>
</div>
